import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Load layout components
import PageSpinner from '../components/layout/PageSpinner';
import StablesComponent from '../components/stables/StablesComponent';

import { GlobalContext } from '../store/Provider';

const Stables = () => {
  const { t } = useTranslation();

  const { stablesState } = useContext(GlobalContext);

  return (
    <Fragment>
      <h1>{t('stables.name')}</h1>
      {stablesState.stables.fetching ? (
        <PageSpinner msg={t('general.stillFetchingData')} />
      ) : (
        <StablesComponent />
      )}
    </Fragment>
  );
};

export default Stables;
